module.exports = __webpack_public_path__ + "img/integral-item5.0fc44192.jpg";